import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, Download, Heart } from "lucide-react";
import { PageHero } from "./About";
import { QuickFactsCard } from "./campus-life/CampusLifePageParts";

const bloodDonationReport =
  "/Clubs/Red-Ribbon-Red-Cross/blood-donation-camp-16-03-2017.pdf";
const bloodDonationReport2026 =
  "/Clubs/Red-Ribbon-Red-Cross/blood-donation-camp-16-03-2026.pdf";
const engineersDayBloodDonationReport =
  "/Clubs/Red-Ribbon-Red-Cross/blood-donation-camp-engineers-day-18-09-2024.pdf";
const engineersDayBloodDonationReport2025 =
  "/Clubs/Red-Ribbon-Red-Cross/blood-donation-camp-engineers-day-19-09-2025.pdf";
const appreciationCertificate =
  "/Clubs/Red-Ribbon-Red-Cross/certificate-of-appreciation-principal-vdit.pdf";
const addictionAwarenessReport =
  "/Clubs/Red-Ribbon-Red-Cross/awareness-program-addiction-risks-law-19-05-2026.pdf";
const cancerTherapyReport =
  "/Clubs/Red-Ribbon-Red-Cross/karnataak-cancer-therapy-research-institute-08-09-2025.pdf";

const activityRows = [
  ["01", "Blood Donation Camp", "16-03-2017"],
  ["02", "Blood Donation Camp on occasion of Engineers Day", "18-09-2024"],
  ["03", "Karnataak Cancer Therapy & Research Institute Programme", "08-09-2025"],
  ["04", "Blood Donation Camp on occasion of Engineers Day", "19-09-2025"],
  ["05", "Awareness Program on Addiction: the Risks & the Law", "19-05-2026"],
  ["06", "Blood Donation Camp", "16-03-2026"],
  ["07", "HIV/AIDS Awareness Programme", "To be updated"],
  ["08", "World AIDS Day Observation", "To be updated"],
  ["09", "Health Awareness Campaign", "To be updated"],
];

const activities = [
  {
    title: "Blood Donation Camp (16-03-2017)",
    description:
      "Voluntary blood donation initiative conducted to promote humanitarian service and healthcare support.",
    report: bloodDonationReport,
  },
  {
    title: "Blood Donation Camp on occasion of Engineers Day (18-09-2024)",
    description:
      "Voluntary blood donation camp organized on the occasion of Engineers Day to encourage service and community healthcare support.",
    report: engineersDayBloodDonationReport,
  },
  {
    title: "Karnataak Cancer Therapy & Research Institute Programme (08-09-2025)",
    description:
      "Awareness programme connected with cancer therapy and research, encouraging health education and preventive care.",
    report: cancerTherapyReport,
  },
  {
    title: "Blood Donation Camp on occasion of Engineers Day (19-09-2025)",
    description:
      "Voluntary blood donation camp organized on the occasion of Engineers Day to encourage service and community healthcare support.",
    report: engineersDayBloodDonationReport2025,
  },
  {
    title: "Awareness Program on Addiction: the Risks & the Law (19-05-2026)",
    description:
      "Awareness programme focused on addiction risks, legal consequences, and responsible choices among students.",
    report: addictionAwarenessReport,
  },
  {
    title: "Blood Donation Camp (16-03-2026)",
    description:
      "Voluntary blood donation initiative conducted to promote humanitarian service and healthcare support.",
    report: bloodDonationReport2026,
  },
  {
    title: "Certificate of Appreciation to Principal of VDIT",
    description:
      "Certificate of appreciation recognizing the institution's support and contribution to service activities.",
    report: appreciationCertificate,
  },
  {
    title: "HIV/AIDS Awareness Programme",
    description:
      "Awareness programme conducted to educate students about HIV prevention, health awareness, and social responsibility.",
    report: "#",
  },
  {
    title: "World AIDS Day Observation",
    description:
      "Student participation in awareness activities promoting health education and community engagement.",
    report: "#",
  },
  {
    title: "Health Awareness Campaign",
    description:
      "Awareness drive encouraging healthy lifestyles, preventive healthcare, and social responsibility.",
    report: "#",
  },
];

const quickFacts = [
  ["Category", "Student Clubs"],
  ["Club", "Red Ribbon Club"],
  ["Focus", "Health Awareness"],
  ["Activity Year", "2025-26"],
  ["Community Outreach", "Yes"],
];

const objectives = [
  "To conduct social and health awareness programmes and promote health consciousness among youth.",
  "To create awareness on the care of one's own health and that of others.",
  "To encourage students to extend humanitarian service to society.",
  "To provide First Aid training and awareness to all volunteers.",
  "To develop leadership, compassion, and a sense of social responsibility among the youth.",
  "To promote voluntary service, national integration, and community welfare activities.",
];

const roles = [
  "Promote humanitarian principles among students and the community.",
  "Develop awareness about personal and public health, hygiene, and safety among youth.",
  "Encourage voluntary service activities including blood donation, first-aid training, disaster relief support, and community welfare efforts.",
  "Form student volunteers to participate in service-oriented activities.",
];

const RedRibbonClub = () => (
  <main>
    <PageHero
      title="Red Ribbon Club"
      sub="Health awareness, social responsibility and community engagement"
      image="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=2400&q=80"
    />

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
      <Link
        to="/clubs"
        className="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:underline mb-8"
      >
        <ArrowLeft size={16} />
        Back to Clubs
      </Link>

      <div className="grid lg:grid-cols-3 gap-8">
        <section className="lg:col-span-2 bg-white border border-brand/15 p-7 md:p-9">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 border border-brand/20 flex items-center justify-center text-brand">
              <Heart size={22} />
            </div>

            <p className="text-xs uppercase tracking-[0.24em] text-brand font-semibold">
              Health & Awareness Club
            </p>
          </div>

          <h2
            className="text-3xl md:text-5xl text-brand font-semibold"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Red Ribbon Club Activities
          </h2>

          <p className="mt-5 text-[16px] text-[#2a2a2a]/85 leading-relaxed">
            Youth Red Cross (YRC) is the youth wing of the Indian Red Cross Society, dedicated to inspiring and empowering young people to uphold the humanitarian principles of the Red Cross Movement.
          </p>

        </section>

        <aside className="bg-white border border-brand/15 p-5">
          <QuickFactsCard facts={quickFacts} />
        </aside>
      </div>

      <section className="mt-12 grid lg:grid-cols-2 gap-6">
        <article className="bg-white border border-brand/15 p-6">
          <h3
            className="text-2xl text-brand font-semibold mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Objectives
          </h3>
          <ul className="space-y-3 text-[15px] text-[#2a2a2a]/85">
            {objectives.map((objective) => (
              <li key={objective} className="flex gap-3">
                <span className="text-brand font-semibold">•</span>
                <span>{objective}</span>
              </li>
            ))}
          </ul>
        </article>

        <article className="bg-white border border-brand/15 p-6">
          <h3
            className="text-2xl text-brand font-semibold mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Roles and Responsibilities
          </h3>
          <ul className="space-y-3 text-[15px] text-[#2a2a2a]/85">
            {roles.map((role) => (
              <li key={role} className="flex gap-3">
                <span className="text-brand font-semibold">•</span>
                <span>{role}</span>
              </li>
            ))}
          </ul>
        </article>
      </section>

      <section className="mt-12">
        <figure className="bg-white border border-brand/15 overflow-hidden">
          <img
            src="/RedRibbon/certificate.jpg"
            alt="Red Ribbon Club Certificate"
            className="w-full max-h-[780px] object-contain bg-white"
            loading="lazy"
          />
          <figcaption className="px-5 py-4 border-t border-brand/10">
            <h3
              className="text-2xl text-brand font-semibold"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Red Ribbon Club Certificate
            </h3>
          </figcaption>
        </figure>
      </section>

      {/* Activities Table */}

      {/* <section className="mt-12">
        <div className="bg-white border border-brand/15 overflow-hidden">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="border p-3 text-left">Sl. No</th>
                <th className="border p-3 text-left">Activity</th>
                <th className="border p-3 text-left">Date</th>
              </tr>
            </thead>
            <tbody>
              {activityRows.map(([id, title, date]) => (
                <tr key={id}>
                  <td className="border p-3">{id}</td>
                  <td className="border p-3">{title}</td>
                  <td className="border p-3">{date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section> */}

      {/* Activity Cards */}

      <section className="mt-12">
        <div className="grid md:grid-cols-2 gap-5">
          {activities.map((activity) => (
            <article
              key={activity.title}
              className="bg-white border border-brand/15 p-5"
            >
              <div className="flex gap-3">
                <Calendar size={18} />
                <div>
                  <h3 className="text-xl text-brand font-semibold">
                    {activity.title}
                  </h3>

                  <p className="mt-2 text-sm text-[#2a2a2a]/85">
                    {activity.description}
                  </p>

                  <a
                    href={activity.report}
                    className="inline-flex items-center gap-2 mt-4 bg-brand text-white px-4 py-2 text-xs font-semibold"
                  >
                    <Download size={14} />
                    View Report
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </section>
  </main>
);

export default RedRibbonClub;
